import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import IProduct from "../../models/product";
//MaterialUI
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CardMedia from "@material-ui/core/CardMedia";
import CircularProgress from "@material-ui/core/CircularProgress";

import DeleteIcon from "@material-ui/icons/Delete";
import Icon from "@material-ui/core/Icon";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import {
  deleteProduct,
  getAllProducts,
} from "../redux/slices/product/productSlice";
import ItemTable from "../items/ItemTable";
import { getAllSteps } from "../redux/slices/step/stepSlice";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export default function ProductDetail() {
  const { slug } = useParams<any>();
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProducts());
  }, [dispatch]);

  const Products: IProduct[] = useSelector((state) => state.product.data);
  const filteredArray: any = Products.find((product) => product.slug === slug);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(deleteProduct(slug));
  };

  if (!filteredArray || filteredArray.length === 0) {
    return (
      <div>
        <CircularProgress />
      </div>
    );
  } else {
    return (
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <div className={classes.paper}> </div>
        <div className="{classes.heroContent}">
          <>
            <Container key={filteredArray.id} maxWidth="sm">
              <Typography
                component="h1"
                variant="h2"
                align="center"
                color="textPrimary"
                gutterBottom
              >
                {filteredArray.name}
              </Typography>{" "}
              <CardMedia
                image={filteredArray.product_image}
                title="Image title"
                component="img"
              />
              <Button
                variant="contained"
                color="primary"
                className="{classes.button}"
                endIcon={<Icon>send</Icon>}
              >
                Start assembly
              </Button>
              <Link
                to={
                  `/department/production-dashboard/product-list/product/` +
                  slug +
                  `/edit`
                }
              >
                <Button
                  variant="contained"
                  color="primary"
                  className="{classes.button}"
                  startIcon={<DeleteIcon />}
                >
                  Edit product
                </Button>
              </Link>
              <Button
                variant="contained"
                color="primary"
                className="{classes.button}"
                startIcon={<DeleteIcon />}
                onClick={handleSubmit}
              >
                Delete product
              </Button>
              <Button
                variant="contained"
                color="primary"
                className="{classes.button}"
                startIcon={<FolderOpenIcon />}
              >
                Drawings
              </Button>
              <ItemTable props={filteredArray.item_list} />
            </Container>
          </>
        </div>
      </Container>
    );
  }
}
